import { Fragment } from "react";
import { auth } from "../services/auth";
import { useState, useEffect } from "react";
import Pagination from "../pagination/pagination";
import Moment from "moment";
import GeneralPopup from "../shared/GeneralPopup";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { getUsers, disableUsers, enableUsers } from "../services/previewUsers";
import styles from "../css/previewUsers.module.css";

function PreviewUsers() {
  const isAdmin = auth().isAdmin();
  const token = auth().getToken();

  let PageSize = 15;
  let data = [];
  let totalRecords = 0;

  const [currentPage, setCurrentPage] = useState(1);
  const [users, setUsers] = useState(null);
  const [showPopup, setPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (isAdmin) {
      getUsers(currentPage, PageSize, config).then((response) => {
        setUsers(response.data);
      });
    } else {
      navigate("/");
    }
  }, [currentPage, refresh]);

  if (users != null) {
    data = users?.data;
  }

  if (users?.totalRecords != null) {
    totalRecords = users?.totalRecords;
  }

  const togglePopup = (value, ref = true) => {
    setSelectedUser(data[value]);
    if (ref) {
      setPopup(!showPopup);
    }
  };

  const disableUser = (value) => {
    disableUsers(value, config).then((response) => {
      setRefresh(!refresh);
      setSelectedUser({ ...selectedUser, disableAccount: true });
    });
  };

  const enableUser = (value) => {
    enableUsers(value, config).then((response) => {
      setRefresh(!refresh);
      setSelectedUser({ ...selectedUser, disableAccount: false });
    });
  };

  return (
    <section className="my-20 px-3 lg:px-10">
      <Helmet>
        <title>Dailysocialboost | Users</title>
      </Helmet>
      <h2 className="text-xl font-bold my-10">Users</h2>
      {data.length > 0 ? (
        <div className="flex flex-row justify-center">
          <div className="grid grid-cols-12 gap-1">
            <div className="font-semibold flex flex-row items-center col-span-2">User ID</div>
            <div className="font-semibold flex flex-row items-center">First Name</div>
            <div className="font-semibold flex flex-row items-center">Last Name</div>
            <div className="font-semibold flex flex-row items-center col-span-3">Email</div>
            <div className="font-semibold flex flex-row items-center col-span-2">Created</div>
            <div className="font-semibold flex flex-row items-center">Confirmed</div>
            <div className="font-semibold flex flex-row items-center">Disabled</div>
            <div className="font-semibold flex flex-row items-center"></div>
            <div className="col-span-12">
              <hr />
            </div>
            {data?.map((item, idx) => (
              <Fragment key={item?.id}>
                <div className="grid grid-cols-12 col-span-12 gap-1 hover:bg-pink-100 transition-all">
                  <div className="flex flex-row items-center col-span-2">{item.id}</div>
                  <div className="flex flex-row items-center">{item.firstName}</div>
                  <div className="flex flex-row items-center">{item.lastName}</div>
                  <div className="flex flex-row items-center col-span-3">{item.email}</div>
                  <div className="flex flex-row items-center col-span-2">
                    {Moment(item.timestamp).format("YYYY-MM-DD : HH:mm")}
                  </div>
                  <div className="flex flex-row items-center">
                    {item.isEmailConfirmed ? "Yes" : "No"}
                  </div>
                  <div className="flex flex-row items-center">
                    {item.disableAccount ? "Yes" : "No"}
                  </div>
                  <div className="flex flex-row items-center">
                    <button
                      className="font-semibold"
                      id={idx}
                      onClick={(e) => togglePopup(e.target.id)}
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        </div>
      ) : (
        <>No users yet!</>
      )}
      <div className="mt-12">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalRecords}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      {showPopup ? (
        <GeneralPopup title={"User Details"} closePopup={togglePopup}>
          <div>
            User{" "}
            <span className="font-semibold">
              {selectedUser.disableAccount ? "Disabled" : "Enabled"}
            </span>
            <div>
              {selectedUser.disableAccount ? (
                <button
                  className={`my-5 px-10 py-3 w-64 ${styles.enableUserBtn}`}
                  id={selectedUser.id}
                  onClick={(e) => enableUser(e.target.id)}
                >
                  Enable User
                </button>
              ) : (
                <button
                  className={`my-5 px-10 py-3 w-64 ${styles.disableUserBtn}`}
                  id={selectedUser.id}
                  onClick={(e) => disableUser(e.target.id)}
                >
                  Disable User
                </button>
              )}
            </div>
          </div>
        </GeneralPopup>
      ) : null}
    </section>
  );
}

export default PreviewUsers;
